import script from "./AppPageHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppPageHeader.vue?vue&type=script&setup=true&lang=ts"

import "./AppPageHeader.vue?vue&type=style&index=0&id=7c55e57a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c55e57a"]])

export default __exports__